import React, { Component } from "react";
import Card from "../../components/Card";
import Action from "../../components/Action";
import Heading from "../../components/Heading";
import TextQuestion from "../../components/TextQuestion";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageCatAndHousePlant from "../../images/cat-and-houseplant.png";

class YourName extends Component {
  constructor(props) {
    super(props);

    const errorMessages = {
      firstName: "Enter your first name",
      lastName: "Enter your last name",
    };

    if (this.props.yourName) {
      const details = this.props.yourName;
      this.state = {
        client1: { ...details.client1 },
        errors: { ...details.errors },
        errorMessages: errorMessages,
      };
    } else {
      this.state = {
        client1: {
          companyName: "",
          firstName: "",
          lastName: "",
        },
        errors: {},
        errorMessages: errorMessages,
      };
    }
  }

  handleValidation() {
    const fields = { ...this.state.client1 };
    const errorMessages = { ...this.state.errorMessages };

    let errors = {};
    let formIsValid = true;

    if (!fields["firstName"]) {
      const field = "firstName";
      formIsValid = false;
      errors[field] = errorMessages[field];
    }

    if (!fields["lastName"]) {
      const field = "lastName";
      formIsValid = false;
      errors[field] = errorMessages[field];
    }

    this.setState({ errors });
    return formIsValid;
  }

  handleFieldValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    this.setState((prevState) => {
      let errors = { ...prevState.errors };
      const errorMessages = { ...prevState.errorMessages };

      if (!isBlur) {
        errors[field] = null;
      } else {
        if (!prevState.client1[field]) {
          errors[field] = errorMessages[field];
        }
      }

      return { errors };
    });
  };

  handleClient1 = (field) => (event) => {
    let client1 = { ...this.state.client1 };
    client1[field] = event;
    this.setState({ client1 });
  };

  saveYourName = (event) => {
    event.preventDefault();

    if (this.handleValidation()) {
      this.props.onStepComplete({
        yourName: {
          client1: this.state.client1,
          errors: this.state.errors,
        },
      });
      return;
    }
  };

  render() {
    return (
      <React.Fragment>
        <ScrollToTop />
        <Card
          title="Our promise: straightforward conveyancing that’s clear, convenient and
          reliable"
          removeTopPadding
        >
          <Heading level="2" size="4">
            Let’s get started. It’ll take about 5 minutes to sign up.
          </Heading>

          {this.props.clientIsCompany && (
            <TextQuestion
              question="What's the registered name of your company?"
              optional={true}
              hint="If you don't yet know your company name, please leave this blank."
              value={this.state.client1.companyName || ""}
              valueEntered={this.handleClient1("companyName")}
            />
          )}

          <TextQuestion
            question="What’s your first name?"
            autoComplete="given-name"
            value={this.state.client1.firstName || ""}
            valueEntered={this.handleClient1("firstName")}
            validate={this.handleFieldValidation("firstName")}
            validationError={this.state.errors.firstName ? this.state.errors.firstName : null}
          />

          <TextQuestion
            question="And your last name?"
            autoComplete="family-name"
            value={this.state.client1.lastName || ""}
            valueEntered={this.handleClient1("lastName")}
            validate={this.handleFieldValidation("lastName")}
            validationError={this.state.errors.lastName ? this.state.errors.lastName : null}
          />

          <Action onClick={this.saveYourName}>Continue</Action>
        </Card>
        <Image src={imageCatAndHousePlant} />
      </React.Fragment>
    );
  }
}

export default YourName;
